import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useContext, useMemo } from 'react';
import { Field as HeadlessField } from '../Field';
import { Context } from './Context';
import { DISPLAY_NAME_FIELD } from './constants';
const Field = forwardRef((props, ref) => {
    const { id } = useContext(Context);
    const memoizedId = useMemo(() => id, [id]);
    return _jsx(HeadlessField, { ...props, id: memoizedId, ref: ref });
});
Field.displayName = DISPLAY_NAME_FIELD;
export { Field };
//# sourceMappingURL=Field.js.map